export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-percent-line',
      title: 'Capital con 0% Interés Promocional',
      description: 'Accede a capital por tiempo limitado sin pagar intereses durante el período promocional, maximizando tu flujo de efectivo.'
    },
    {
      icon: 'ri-building-line',
      title: 'Separación Financiera Estratégica',
      description: 'Diferencia tus finanzas personales de las del negocio con estructuras LLC o corporativas cuando aplique, protegiendo tu patrimonio.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Maximización de Aprobaciones',
      description: 'Estrategia profesional para aumentar tus probabilidades de aprobación y conseguir los montos más altos posibles.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Acompañamiento Inteligente',
      description: 'Te guiamos en cómo usar el capital de forma estratégica para hacer crecer tu negocio o inversiones de manera sostenible.'
    }
  ];

  return (
    <section className="py-24 bg-[#050505] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Beneficios <span className="text-[#D4AF37]">Principales</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Descubre cómo nuestro servicio de Funding puede transformar tu capacidad financiera
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-[#1C1C1C] p-8 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/20"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#F4D03F] rounded-lg flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300">
                <i className={`${benefit.icon} text-[#050505] text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4 leading-tight">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-[#1C1C1C] px-8 py-4 rounded-full border border-[#D4AF37]/30">
            <p className="text-gray-300">
              <i className="ri-star-line text-[#D4AF37] mr-2"></i>
              <strong className="text-white">Resultado:</strong> Capital estratégico para hacer crecer tu negocio sin comprometer tu flujo de caja
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
